import { useState } from "react";
import { useScrollAnimation, useScrollAnimationMultiple } from "@/hooks/useScrollAnimation";

const projects = [
  {
    id: 0,
    name: "Sai Meadows Phase I",
    location: "Kodathi / Muthanallur, Sarjapur Road",
    type: "Villa Plots",
    status: "Completed",
    desc: "Urban Infra's first landmark gated community with wide roads, drainage, and all amenities on Sarjapur Road.",
    image: "https://storage.readdy-site.link/project_files/1dbbbcb9-2ec8-461f-ad48-b9a0f216246f/ae087bfc-ce14-4e14-95f9-b6034e60e155_IMG-20260421-WA0040.jpg?v=d6168ca4571ee4d7f338ca78f236c39a",
    href: "/urbaninfra",
  },
  {
    id: 1,
    name: "Sai Meadows Phase II",
    location: "Kodathi / Muthanallur, Sarjapur Road",
    type: "Villa Plots",
    status: "Completed",
    desc: "Premium gated community villa plots on Sarjapur Road with all modern amenities.",
    image: "https://storage.readdy-site.link/project_files/1dbbbcb9-2ec8-461f-ad48-b9a0f216246f/baaf4e8a-c47f-41a4-81a1-8e472f54da09_IMG-20260421-WA0038.jpg?v=5574df50463f96d77b235315d867a7f6",
    href: "/urbaninfra",
  },
  {
    id: 2,
    name: "Sai Meadows Phase III",
    location: "Kodathi / Muthanallur, Sarjapur Road",
    type: "Villa Plots",
    status: "Completed",
    desc: "Exclusive gated community residential layout near Sarjapur Main Road with eco-friendly planning.",
    image: "https://storage.readdy-site.link/project_files/1dbbbcb9-2ec8-461f-ad48-b9a0f216246f/eadb86ee-68c8-4d20-810f-adf820c3a635_IMG-20260421-WA0035.jpg?v=8d416b0f6c76ece4feb5e2f08a0edb48",
    href: "/urbaninfra",
  },
  {
    id: 3,
    name: "Anaaya Bliss",
    location: "Kodathi Village, Sarjapur Road",
    type: "Villa Plots",
    status: "Completed",
    desc: "Premium villa plots on Sarjapur Road with modern infrastructure and peaceful surroundings.",
    image: "https://storage.readdy-site.link/project_files/1dbbbcb9-2ec8-461f-ad48-b9a0f216246f/b5edef9e-30cf-4660-832c-aa261788b06f_IMG-20260421-WA0037.jpg?v=2413de3686c76b034a9b5fdb454d0f92",
    href: "/urbaninfra",
  },
  {
    id: 4,
    name: "Urban Meadows",
    location: "Dommasandra, Sarjapur Road",
    type: "Residential Layout",
    status: "Completed",
    desc: "Premium residential plots on Sarjapur Road in the Dommasandra region with excellent connectivity.",
    image: "https://storage.readdy-site.link/project_files/1dbbbcb9-2ec8-461f-ad48-b9a0f216246f/20528057-1e0d-4ee7-861f-573db102fe87_IMG-20260421-WA0043.jpg?v=d83a6c3851231c43ff92f9d4db02bad6",
    href: "/urbaninfra",
  },
  {
    id: 5,
    name: "Green Earth",
    location: "On Sarjapur Road, Bengaluru",
    type: "Eco-Friendly Layout",
    status: "Completed",
    desc: "Eco-friendly residential layout surrounded by greenery while maintaining excellent city connectivity.",
    image: "https://storage.readdy-site.link/project_files/1dbbbcb9-2ec8-461f-ad48-b9a0f216246f/079b6c3a-a4b7-44f1-97f1-f363455aa3e5_IMG-20260421-WA0039.jpg?v=663ce244df2e1ff43fb8e46465883ad2",
    href: "/urbaninfra",
  },
  {
    id: 6,
    name: "Urban Nest",
    location: "On Sarjapur Road, Bengaluru",
    type: "Residential Plots",
    status: "Completed",
    desc: "Affordable villa plots on Sarjapur Road — ideal for first-time buyers and budget investors.",
    image: "https://storage.readdy-site.link/project_files/1dbbbcb9-2ec8-461f-ad48-b9a0f216246f/92391308-6311-4535-ba90-12f0b638afda_IMG-20260421-WA0041.jpg?v=0d6f04ed5994769ccdebc37f85c1e73b",
    href: "/urbaninfra",
  },
  {
    id: 7,
    name: "Amber Park",
    location: "Herabana Village, Laxmeshwar",
    type: "Villa Plots",
    status: "Ongoing",
    desc: "New launch premium villa plots at Herabana Village, Laxmeshwar. Limited plots available at early-stage pricing.",
    image: "https://storage.readdy-site.link/project_files/1dbbbcb9-2ec8-461f-ad48-b9a0f216246f/03dd1286-676e-40f1-a282-9015126e8bc7_IMG-20260421-WA0036.jpg?v=734e2d1c4d5b11f4a38070ee00668d25",
    href: "/urbaninfra",
  },
  {
    id: 8,
    name: "Urban Palms",
    location: "Chokkasandra Village, Sarjapur Road",
    type: "Premium Villa Plots",
    status: "Ongoing",
    desc: "Flagship premium gated community on Sarjapur Road in Chokkasandra Village.",
    image: "https://storage.readdy-site.link/project_files/1dbbbcb9-2ec8-461f-ad48-b9a0f216246f/b8d967c3-b9bb-4ca0-a5ee-4fbd6b6be13a_IMG-20260421-WA0042.jpg?v=00d3991808a8aceb60c2dc91ce500d44",
    href: "/urbaninfra",
  },
];

const filters = ["All", "Completed", "Ongoing"];

export default function Projects() {
  const [activeFilter, setActiveFilter] = useState("All");
  const { ref: headRef, isVisible: headVisible } = useScrollAnimation();
  const { setRef, visibleItems } = useScrollAnimationMultiple(projects.length);

  const filtered = activeFilter === "All" ? projects : projects.filter((p) => p.status === activeFilter);

  return (
    <section id="projects" className="bg-white py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div
          ref={headRef as (el: HTMLDivElement | null) => void}
          className={`flex flex-col md:flex-row md:items-end justify-between gap-6 mb-10 reveal ${headVisible ? "visible" : ""}`}
        >
          <div>
            <span className="inline-block text-xs font-bold uppercase tracking-widest text-[#7FBF3F] bg-[#EAF5E1] px-3 py-1.5 rounded-full mb-3">
              Our Portfolio
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-[#1B2A4A]" style={{ fontFamily: "'Playfair Display', serif" }}>
              Projects
            </h2>
          </div>
          <div className="flex flex-wrap gap-2">
            {filters.map((f) => (
              <button
                key={f}
                onClick={() => setActiveFilter(f)}
                className={`btn-hover text-xs font-semibold px-5 py-2 rounded-full border transition-all duration-200 cursor-pointer whitespace-nowrap ${
                  activeFilter === f
                    ? "bg-[#7FBF3F] text-white border-[#7FBF3F]"
                    : "bg-white text-gray-600 border-gray-200 hover:border-[#7FBF3F] hover:text-[#7FBF3F]"
                }`}
              >
                {f}
              </button>
            ))}
          </div>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {filtered.map((project, i) => (
            <a
              key={project.id}
              href="/urbaninfra"
              ref={setRef(i) as (el: HTMLAnchorElement | null) => void}
              className={`card-hover bg-white rounded-2xl overflow-hidden border border-gray-100 hover:border-[#7FBF3F]/30 transition-all duration-300 block reveal reveal-delay-${Math.min(i + 1, 6)} ${visibleItems[i] ? "visible" : ""}`}
            >
              <div className="relative h-44 img-zoom overflow-hidden">
                <img
                  src={project.image}
                  alt={`${project.name} - villa plots on Sarjapur Road`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                {/* Gradient overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                <div className={`absolute top-3 left-3 text-xs font-bold px-3 py-1 rounded-full ${project.status === "Ongoing" ? "bg-[#F36F21] text-white" : "bg-[#EAF5E1] text-[#7FBF3F] border border-[#7FBF3F]/20"}`}>
                  {project.status === "Ongoing" && <span className="inline-block w-1.5 h-1.5 bg-white rounded-full mr-1 animate-pulse"></span>}
                  {project.status}
                </div>
              </div>
              <div className="p-4">
                <div className="text-xs text-[#7FBF3F] font-medium mb-1">{project.type}</div>
                <h3 className="font-bold text-[#1B2A4A] text-base mb-1" style={{ fontFamily: "'Playfair Display', serif" }}>{project.name}</h3>
                <div className="flex items-center gap-1 text-gray-500 text-xs mb-2">
                  <i className="ri-map-pin-line text-[#F36F21]"></i>
                  {project.location}
                </div>
                <p className="text-gray-600 text-xs leading-relaxed mb-3 line-clamp-2">{project.desc}</p>
                <div className="w-full flex items-center justify-center gap-1.5 bg-[#7FBF3F] hover:bg-[#6aaa32] text-white text-xs font-semibold py-2.5 rounded-lg transition-colors">
                  View Projects
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="/urbaninfra"
            className="btn-hover inline-flex items-center gap-2 border-2 border-[#1B2A4A] text-[#1B2A4A] hover:bg-[#1B2A4A] hover:text-white font-semibold px-8 py-3 rounded-xl cursor-pointer whitespace-nowrap"
          >
            View All Projects
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
